var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBedBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4375 21.125V15.4375C2.44005 14.5763 2.78327 13.7512 3.39221 13.1422C4.00116 12.5333 4.82633 12.19 5.6875 12.1875H20.3125C21.1737 12.19 21.9988 12.5333 22.6078 13.1422C23.2167 13.7512 23.56 14.5763 23.5625 15.4375V21.125M19.5 12.1875H4.875V6.90625C4.87661 6.36802 5.09113 5.8523 5.47171 5.47171C5.8523 5.09113 6.36802 4.87661 6.90625 4.875H19.0938C19.632 4.87661 20.1477 5.09113 20.5283 5.47171C20.9089 5.8523 21.1234 6.36802 21.125 6.90625V12.1875H19.5Z",
    stroke: "#034A73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4375 21.125V20.7188C2.43844 20.3958 2.56714 20.0864 2.7955 19.858C3.02386 19.6296 3.33331 19.5009 3.65625 19.5H22.3438C22.6667 19.5009 22.9761 19.6296 23.2045 19.858C23.4329 20.0864 23.5616 20.3958 23.5625 20.7188V21.125M5.6875 12.1875V11.375C5.68871 10.9444 5.8603 10.5318 6.16478 10.2273C6.46927 9.9228 6.88189 9.75121 7.3125 9.75H11.375C11.8056 9.75121 12.2182 9.9228 12.5227 10.2273C12.8272 10.5318 12.9988 10.9444 13 11.375M13 11.375V12.1875M13 11.375C13.0012 10.9444 13.1728 10.5318 13.4773 10.2273C13.7818 9.9228 14.1944 9.75121 14.625 9.75H18.6875C19.1181 9.75121 19.5307 9.9228 19.8352 10.2273C20.1397 10.5318 20.3113 10.9444 20.3125 11.375V12.1875",
    stroke: "#034A73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedBlue);
export default __webpack_public_path__ + "static/media/bedBlue.1dec42d0026313f231c06ff14e363e6c.svg";
export { ForwardRef as ReactComponent };